import Index from "@components/index/Index"

export default function Page(){
  return <Index/>
}
